export default () => {
  /* istanbul ignore else */
  if (process.env.GRAPHQL_MOCK) {
    return require('../../mocks/notification-apollo-client-mock').default; // eslint-disable-line global-require
  } else {
    return require('./clients/notification-apollol-client').default; // eslint-disable-line global-require
  }
};
